import React from 'react';
import { Button } from 'react-bootstrap';
import PropdocsModal from '../modal/PropdocsModal';
import { ReactComponent as UsersIcon } from '../../shared/icons/users-group-people.svg';
import styles from './styles.module.scss';

interface DeleteContactModalProps {
  contact: {
    id: string;
    name: string;
    boundDocumentsCount?: number;
  } | null;
  onConfirm: () => void;
  onCancel: () => void;
  isDeleting: boolean;
}

export const DeleteContactModal: React.FC<DeleteContactModalProps> = ({
  contact,
  onConfirm,
  onCancel,
  isDeleting,
}) => {
  const hasAssociatedDocuments = (contact?.boundDocumentsCount || 0) > 0;

  return (
    <PropdocsModal
      show={!!contact}
      setShow={onCancel}
      title={<>Delete Contact?</>}
      size="md"
    >
      <div className={styles.deleteModalContent}>
        <div className={styles.deleteModalBody}>
          {hasAssociatedDocuments ? (
            <>
              <div className={styles.deleteWarning}>
                <UsersIcon width={24} height={24} />
                <p>
                  <strong>{contact?.name}</strong> is linked to {contact?.boundDocumentsCount} document{(contact?.boundDocumentsCount || 0) > 1 ? 's' : ''}.
                </p>
              </div>
              <p className={styles.deleteWarningText}>
                This contact cannot be deleted while it is associated with documents.
                To delete this contact, first remove the contact binding from all associated documents.
              </p>
            </>
          ) : (
            <p>
              Are you sure you want to delete <strong>{contact?.name}</strong>? This action cannot be undone.
            </p>
          )}
        </div>
        <div className={styles.deleteModalActions}>
          <Button
            variant="link"
            className="text-secondary"
            onClick={onCancel}
            disabled={isDeleting}
          >
            {hasAssociatedDocuments ? 'Close' : 'Cancel'}
          </Button>
          {!hasAssociatedDocuments && (
            <Button
              variant="danger"
              onClick={onConfirm}
              disabled={isDeleting}
            >
              {isDeleting ? 'Deleting...' : 'Delete'}
            </Button>
          )}
        </div>
      </div>
    </PropdocsModal>
  );
};

export default DeleteContactModal;
